module.exports = __webpack_public_path__ + "static/media/paid-loan.29a48eb2.svg";